/* ============================================================
   SINGSPACE ADMIN - CONTRÔLE SESSION WHATSAPP (Sobre)
   ============================================================ */

import { Play, Power, Smartphone } from 'lucide-react';
import { SessionStatus } from '../../types/whatsapp.types';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { QRCodeCard } from './QRCodeCard';

interface SessionControlProps {
  sessionStatus: SessionStatus;
  handleStartSession: () => void;
  handleSimulateConnect: () => void;
  handleDisconnect: () => void;
}

export function SessionControl({
  sessionStatus,
  handleStartSession,
  handleSimulateConnect,
  handleDisconnect,
}: SessionControlProps) {
  return (
    <Card className="border border-slate-200">
      <div className="p-6 border-b border-slate-100">
        <h3 className="text-sm font-semibold text-slate-900">Contrôle de Session</h3>
        <p className="text-xs text-slate-500 mt-1">Gestion de la connexion WhatsApp Business</p>
      </div>

      <div className="p-6">
        {sessionStatus === 'disconnected' && (
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-lg">
              <Smartphone size={20} className="text-slate-400" />
              <div className="flex-1">
                <p className="text-sm font-medium text-slate-700">Session inactive</p>
                <p className="text-xs text-slate-500 mt-0.5">Démarrez une session pour connecter votre compte</p>
              </div>
            </div>
            <Button onClick={handleStartSession} className="w-full bg-[#00303c] hover:bg-[#00758d] text-white">
              <Play size={16} className="mr-2" />
              Démarrer la session
            </Button>
          </div>
        )}

        {sessionStatus === 'scanning' && (
          <div className="space-y-4">
            <QRCodeCard sessionStatus={sessionStatus} />
            <p className="text-xs text-slate-500 text-center">Scannez le code QR avec votre application WhatsApp</p>
            <Button onClick={handleSimulateConnect} variant="outline" size="sm" className="w-full text-xs">
              Simuler la connexion (Dev)
            </Button>
          </div>
        )}

        {sessionStatus === 'connected' && (
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-4 bg-emerald-50 rounded-lg border border-emerald-100">
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              <div className="flex-1">
                <p className="text-sm font-medium text-emerald-900">Session active</p>
                <p className="text-xs text-emerald-700 mt-0.5">Le bot est opérationnel</p>
              </div>
            </div>
            <Button
              onClick={handleDisconnect}
              variant="outline"
              className="w-full text-rose-600 hover:text-rose-700 hover:bg-rose-50"
            >
              <Power size={16} className="mr-2" />
              Déconnecter
            </Button>
          </div>
        )}
      </div>
    </Card>
  );
}
